@if (selectionModel?.selected?.length == 0) {
    <small class="debug">{{ me }}</small>
    <div fxFlex fxLayout="column" style="height: 100%;">
        <div class="d-flex-center props-header" style="justify-content: center;">
            <mat-icon style="margin-right: 10px;">info</mat-icon>
            <mat-label>{{ 'general.noItemSelected' | transloco }}</mat-label>
        </div>
        <div class="recent-scenes">
            <app-scene-recents [vertical]="true" [count]="5"></app-scene-recents>
        </div>
    </div>
} @else if (selectionModel.selected.length === 1) {
    @if (isSliderScene()) {
        <!-- Slider Scene Header -->
        <div class="panel-header">
            <div class="header-content">
                <div class="title-section">
                    <mat-icon class="title-icon">slideshow</mat-icon>
                    <h3 class="slider-title">{{ renderScenes[0].Player.$.label }}</h3>
                </div>
            </div>
        </div>
    } @else {
        <!-- Regular Scene Header -->
        <div class="d-flex-center props-header">
            <fa-icon size="xl" class="pull-right" style="margin-right: 15px"
                     [icon]="renderScenes[0].Player.$.mimeType | PipeIcon"></fa-icon>
            <span>{{ renderScenes[0].Player.$.label }}</span>
        </div>
    }
    <div>
        <!-- Regular scene content -->
        @if (isPlayerAssignable) {
            <button mat-button class="register-button" (click)="showAddPlayerModal()">
                <mat-icon>queue_play_next</mat-icon>
                {{ 'general.registerPlayer' | transloco }}
            </button>
        }

        @if (isSliderScene()) {
            <app-touch-scene-props [renderScene]="renderScenes[0]"></app-touch-scene-props>
        } @else {
            @if (experienceLevel > experienceLevelType.BEGINNER) {
                <ul>
                    <li>scene id: {{ renderScenes[0].Player.$.id }}</li>
                    <li>mime: {{ renderScenes[0].Player.$.mimeType }}</li>
                    <li>auto scale: {{ renderScenes[0].Player.$.autoScaling }}</li>
                    <li>player type: {{ renderScenes[0].Player.$.player }}</li>
                    <li>items: {{ renderScenes[0]?.Player.Data[0]?.Scene[0]?.Players[0]?.Player?.length }}</li>
                    <li>size: {{ sceneWidth }} x {{ sceneHeight }} px</li>
                </ul>
                <hr />
            }
            <div style="width: 260px; margin-left: 10px">
                @if (isMimeMainPlayer && experienceLevel > experienceLevelType.BEGINNER) {
                    <mat-checkbox (change)="togglePlayerAssignable($event)"
                                  [checked]="isPlayerAssignable">
                        <fa-icon size="lg" [icon]="faPlugCircleCheck"></fa-icon>
                        &nbsp;{{ 'general.playerAssignable' | transloco }}
                    </mat-checkbox>
                }

                <div style="margin-left: 10px">
                    <mat-form-field style="width: 215px;">
                        <mat-label>{{ 'placeholder.name' | transloco }}</mat-label>
                        <input autocomplete="off" inputrestriction="basic1" matInput
                               value="{{renderScenes[0].Player.$.label}}"
                               (keyup)="onChangeSceneName($event)" (change)="onChangeSceneName($event)">
                    </mat-form-field>
                    @if (experienceLevel > experienceLevelType.BEGINNER) {
                        <mat-form-field style="width: 215px;">
                            <mat-label>{{ 'general.accessKey' | transloco }}</mat-label>
                            <mat-select (selectionChange)="changeAccessMask($event.value)" [value]="accessKey">
                                @for (item of accessMask; track item) {
                                    <mat-option [value]="item">{{ item }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        <div class="d-flex-center">
                            <mat-form-field style="width: 210px;">
                                <mat-label>{{ 'placeholder.category' | transloco }}</mat-label>
                                <input inputrestriction="basic1" matInput value="{{category}}" readonly>
                            </mat-form-field>
                            <a mat-icon-button class="mini-button" (click)="openCategoryTree()">
                                <mat-icon>folder_open</mat-icon>
                            </a>
                        </div>
                    }
                </div>
            </div>
        }
        <!-- Only show scene preview for non-slider scenes -->
        @if (!isSliderScene()) {
            <mat-divider></mat-divider>
            <!--    <div *ngIf="isPlayerAssignable && isScheduledEnabled === '1'">-->
                <!--        <app-scenes-scheduler [setSceneSelectionModel]="selectionModel"></app-scenes-scheduler>-->
                <!--    </div>-->
            <mat-divider></mat-divider>
            <br />
            @if (selectedSceneId) {
                <div class="preview-scene">
                    <app-scene-preview
                        [setSelectedSceneId]="selectedSceneId"
                        [setSceneWidth]="sceneWidth"
                        [setSceneHeight]="sceneHeight"
                        [previewWidth]="previewWidth"
                        [autoScale]="true">
                    </app-scene-preview>
                    <div class="overlay">
                        <a style="background-color: #0d66c2" mat-icon-button class="mini-button jump-icon"
                           (click)="navigateToScene(renderScenes[0])" matTooltip="{{'general.jumpToScene' | transloco}}"
                           matTooltipPosition="left">
                            <mat-icon style="color: white">link</mat-icon>
                        </a>
                    </div>
                </div>
            }
            <br />
            <hr />
        }
    </div>
} @else {
    <div class="d-flex-center props-header">
        <mat-icon style="margin-right: 10px;">check</mat-icon>
        <mat-label>Selected scenes:</mat-label>
    </div>
    <div class="d-flex-center" style="margin-left: 15px">
        <mat-form-field style="width: 210px;">
            <mat-label>{{ 'placeholder.category' | transloco }}</mat-label>
            <input inputrestriction="basic1" matInput value="{{category}}" readonly>
        </mat-form-field>
        <a mat-icon-button class="mini-button" (click)="openCategoryTree()">
            <mat-icon>folder_open</mat-icon>
        </a>
    </div>
    <mat-divider></mat-divider>
    <mat-list>
        @for (scene of renderScenes; track scene) {
            <mat-list-item>
                @if (scene.Player.$.mimeType === 'Touch') {
                    <mat-icon matListItemIcon>touch_app</mat-icon>
                } @else {
                    <fa-icon matListItemIcon [icon]="scene.Player.$.mimeType | PipeIcon"></fa-icon>
                }
                <div matListItemTitle>{{ scene.Player.$.label }}</div>
                <div
                    matListItemLine>{{ scene.Player.$?.lastModified ? (scene.Player.$?.lastModified | date) : 'date: none' }}
                </div>
                <div matListItemIcon class="action-icon-group d-flex-center">
                    <mat-icon (click)="navigateToScene(scene)" matTooltip="{{'general.jumpToScene' | transloco}}">link
                    </mat-icon>
                    <mat-icon (click)="toggleSelection(scene.Player.$.id)"
                              matTooltip="{{'general.deselect' | transloco}}">close
                    </mat-icon>
                </div>
            </mat-list-item>
            <hr />
        }
    </mat-list>
}
